export const ENTITY_STATUS_NOT_FOUND = 'notFound'
